export enum LocalStoreKeysEnum {
  INSPECTION_TYPE_KEY = 'inspection-type',
  LABEL_INSPECTION_PRICE = 'label-inspection-price',
  LABEL_INSPECTION_ID = 'inspection-id',
}
